export default "__VITE_ASSET__19530ffd__"